import React from 'react';
import KitLandingLayout from './KitLandingLayout';

const config = {
  slug: 'storebot',
  name: 'StoreBot',
  breadcrumb: 'Kit StoreBot',
  industry: 'showrooms, mueblerías, ferreterías y tiendas con catálogo',
  seoTitle: 'StoreBot — Chatbot WhatsApp para Tiendas con Catálogo',
  seoDescription:
    'El vendedor que conoce cada producto de tu tienda. Catálogo 24/7 por WhatsApp, captura de leads y notificación inmediata al equipo.',
  accent: 'indigo',
  accentHex: '#4F46E5',
  heroEmoji: '🛍️',
  title: 'StoreBot — el vendedor que conoce cada producto de tu tienda',
  tagline:
    'Tu catálogo completo, disponible por WhatsApp 24/7. Responde consultas, entrega precios y captura clientes — automáticamente.',
  stats: [
    { value: '24/7', label: 'atención automática' },
    { value: '∞', label: 'productos en el catálogo' },
    { value: '⚡', label: 'lead al instante por email' },
  ],
  leadTypes: [
    {
      badge: '👔 Profesional',
      title: 'Arquitecto / Diseñador / Empresa',
      body: 'StoreBot detecta el perfil profesional y adapta el tono: descuentos por volumen, plazos de entrega, especificaciones técnicas y contacto directo con ventas B2B.',
    },
    {
      badge: '🛒 Particular',
      title: 'Cliente final',
      body: 'Consulta precios, disponibilidad y agenda visita al local. Si necesita más detalle, deriva a WhatsApp o al equipo de ventas por email.',
    },
  ],
  features: [
    { title: 'Catálogo inteligente', body: 'Conoce cada producto, precio, característica y disponibilidad de tu tienda.' },
    { title: 'Captura de leads', body: 'Registra nombre, teléfono, email, producto de interés y ciudad — todo en la conversación.' },
    { title: 'Notificación inmediata', body: 'Cada lead llega por email al equipo en el mismo instante en que se cierra.' },
    { title: 'Agenda de visitas', body: 'El cliente elige fecha para pasar por el showroom y queda registrada.' },
    { title: 'Detecta el perfil', body: 'Distingue automáticamente si es profesional (arquitecto, empresa) o particular.' },
    { title: 'Widget embebible', highlight: true, body: 'Se instala en cualquier sitio web en 2 minutos con un snippet de HTML.' },
  ],
  flowSubtitle: 'Del primer mensaje al lead capturado en 5 pasos.',
  flow: [
    { title: 'Escribe por WhatsApp o widget web', body: 'StoreBot saluda y detecta qué producto o servicio necesita el cliente.' },
    { title: 'Identifica perfil y contexto', body: 'Profesional o particular, ciudad, y el contexto del proyecto o necesidad.' },
    { title: 'Entrega info del catálogo', body: 'Características, precio orientativo y disponibilidad — todo desde tu knowledge base.' },
    { title: 'Solicita datos de contacto', highlight: true, body: 'Nombre, teléfono, email y fecha preferida de visita.' },
    { title: 'El equipo recibe el lead completo', body: 'Notificación por email con datos + producto de interés + conversación completa.' },
  ],
  mockup: {
    left: {
      title: 'Leads recientes',
      subtitle: 'Últimas 24 horas',
      rows: [
        { primary: 'Camila Torres · Arquitecta', secondary: 'Mesa Roble · Providencia · Visita jueves', status: 'Caliente' },
        { primary: 'Roberto Ávila · Empresa', secondary: 'Cotización 30 lámparas · Concepción', status: 'B2B' },
        { primary: 'Andrea Silva · Particular', secondary: 'Sofá 3 cuerpos · Ñuñoa', status: 'Confirmado' },
        { primary: 'Diego Muñoz · Diseñador', secondary: 'Sillas oficina x8 · Las Condes', status: 'Nuevo' },
      ],
    },
    right: {
      title: 'Productos consultados',
      action: 'Ver catálogo',
      rows: [
        { primary: 'Sofá Escandinavo 3 cuerpos', secondary: '$1.290.000 · Roble natural', badge: 'Nuevo', link: 'Ver ficha' },
        { primary: 'Mesa de Comedor 8p', secondary: '$1.850.000 · Nogal macizo', badge: 'Showroom', link: 'Ver ficha' },
        { primary: 'Lámpara Colgante Ambar', secondary: '$189.000 · Latón + Ámbar', badge: 'Stock', link: 'Ver ficha' },
      ],
    },
  },
  useCases: [
    'Showrooms de diseño y decoración',
    'Mueblerías y tiendas de muebles',
    'Ferreterías con catálogo extenso',
    'Distribuidores e importadores',
  ],
};

export default function StoreBotKitPage() {
  return <KitLandingLayout config={config} />;
}
